import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import LocationOption from '../../../../../_components/Options/LocationOption';
import ReactDatePicker from '../../../../../_components/DatePicker/ReactDatePicker';
import ProfessionalOption from '../../../../../_components/Options/ProfessionalOption';
import RenderValidateMessage from '../../../../../stories/Validation/RenderValidateMessage';

import { useState } from 'react';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

function RescheduleAction({ event, rescheduling, rescheduleEvent }) {
  const [show, setShow] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("")
  const [group, setGroup] = useState("");
  const [errors, setErrors] = useState({});
  const [provider, setProvider] = useState("");

  const handleShow = (e) => {
    e.preventDefault();
    setDate(moment.tz(event.date, event.providerGroup.timezone).local().toDate());
    setTime(event.time ? moment.tz(event.time, 'H:m', event.providerGroup.timezone).local().toDate() : null);
    setGroup({ value: event.providerGroup.id, label: event.providerGroup.name });
    setProvider({ value: event.doctor.id, label: `${event.doctor.firstName} ${event.doctor.firstName}` });
    setErrors({});
    setShow(true);
  }

  const clearAndHideReschedule = () => {
    setDate("");
    setTime("");
    setGroup("");
    setErrors({});
    setProvider("");
    setShow(false)
  }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!date) {
      errors.date = 'Event Date is required.'
    } else if (moment(date).isBefore(new Date())) {
      errors.date = 'Event Date must be upcoming.';
    }

    if (!group.value) {
      errors.group = 'Location is required.';
    }

    if (!provider.value) {
      errors.provider = 'Provider is required.';
    }

    setErrors(errors);

    if (!errors.date && !errors.provider && !errors.events && !errors.group) {
      reschedule();
    }
  }

  const reschedule = () => {
    const updatedEvent = {
      id: event.id,
      type: event.type,
      group: { id: group.value, name: group.label },
      provider: { id: provider.value, name: provider.label },
      date: moment(date).format("LL"),
      time: time ? moment(time).format("HH:mm") : null
    }
    rescheduleEvent(updatedEvent);
    clearAndHideReschedule();
  }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Reschedule</Tooltip>}
    >
      <button
        title="Reschedule"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-edit"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={clearAndHideReschedule}>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Event</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="form-group mb-4">
            <div className="row">
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Event Date</label>
                <ReactDatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  minDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  className="form-control"
                  wrapperClassName="w-100"
                />
                <RenderValidateMessage errors={errors} field="date" />
              </div>
              <div className="col-sm-12 mb-4">
                <label>Event Time</label>
                <DatePicker
                  selected={time}
                  onChange={(time) => setTime(time)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={5}
                  className="form-control"
                  dateFormat="h:mm aa"
                  wrapperClassName="w-100"
                />
                <RenderValidateMessage errors={errors} field="time" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Treating Provider</label>
                <ProfessionalOption defaultValue={provider.value} handleSelected={(value, label) => setProvider({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="provider" />
              </div>
              <div className="col-sm-12">
                <label><span className="text-danger">*</span> Location</label>
                <LocationOption defaultValue={group.value} handleSelected={(value, label) => setGroup({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="group" />
              </div>
            </div>
          </div>
        </form>
        <div className='text-danger'>
          <small>
            <b>Warning: rescheudling an Event date and time will not change event Form CompleteByDate or Telehealth AppointmentDate. This must be done manually.</b>
          </small>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={validate} disabled={rescheduling}>
          {rescheduling ? 'Rescheduling...' : 'Reschedule Event'}
        </Button>
        <Button variant="secondary" onClick={clearAndHideReschedule}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default RescheduleAction;